export function Trash() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 26" fill="none">
      <path
        d="M0.699951 6.22269H12.2471H19.1754V22.2347C19.1754 22.888 18.932 23.5146 18.4989 23.9766C18.0658 24.4386 17.4784 24.6981 16.8659 24.6981H3.00938C2.39688 24.6981 1.80947 24.4386 1.37637 23.9766C0.943265 23.5146 0.699951 22.888 0.699951 22.2347V6.22269Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.699951 3.14453H13.0169H19.1754"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.22046 2.8728V0.699219H12.6544V2.8728"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="10.0085"
        y1="20.9172"
        x2="10.0085"
        y2="10.0002"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <line
        x1="13.0866"
        y1="20.9172"
        x2="13.0866"
        y2="10.0002"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <line
        x1="6.92866"
        y1="20.9172"
        x2="6.92866"
        y2="10.0002"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  )
}
